import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Button, ButtonSizes } from 'ui-components/components/button';
import Global from '../../../store/global-selectors';
import { UserPermissionService } from '../../../services/user-permission-service';

import style from './verification-buttons.module.less';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

const messages = defineMessages({
  verify: {
    description: 'Scan item list verify',
    defaultMessage: 'Verify',
    id: '1wcEEm',
  },
  clear: {
    description: 'Scan item list clear',
    defaultMessage: 'Clear',
    id: 'maAGVh',
  },
});

export const VerificationButtons = ({ disabled = false, onClear, onVerify }) => {
  const userRoles = useSelector(Global.selectUseruserRoles) || [];
  const hasPackingScanPermission = UserPermissionService.userHasPackingScanManualVerificationRole(userRoles);

  if (!hasPackingScanPermission) {
    return null;
  }

  return (
    <div className={style['verification-buttons']}>
      <Button buttonSize={ButtonSizes.large} disabled={disabled || !onVerify} onClick={onVerify} theme={THEME_CONSTANTS.link}>
        <FormattedMessage {...messages.verify} />
      </Button>
      <span className={style.spacer}>|</span>
      <Button buttonSize={ButtonSizes.large} disabled={disabled || !onClear} onClick={onClear} theme={THEME_CONSTANTS.link}>
        <FormattedMessage {...messages.clear} />
      </Button>
    </div>
  );
};

VerificationButtons.propTypes = {
  disabled: PropTypes.bool,
  onClear: PropTypes.func,
  onVerify: PropTypes.func,
};
